import React from "react";
import { useSelector } from "react-redux";
import {
  CircularProgressbar,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function GlobalLoader() {
  const { loading, progress } = useSelector((state) => state.ui);
  const color = "#1b8354";

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur-sm dark:bg-slate-700 dark:text-white bg-gray-200 bg-opacity-80 dark:bg-opacity-100">
      <div className="relative w-35 h-35 flex items-center justify-center dark:bg-slate-700 dark:text-white">
        {/* Circular Progress */}
        <div className="absolute inset-0 dark:bg-slate-700 dark:text-white">
          <CircularProgressbar
            value={progress > 0 ? progress : 10} // show at least small arc
            strokeWidth={4}
            styles={buildStyles({
              pathColor: color,
              trailColor: "rgba(27, 131, 84, 0.2)",
              strokeLinecap: "round",
              pathTransitionDuration: 0.3,
            })}
          />
        </div>

        {/* Center Logo */}
        <img
          src="/logo.png"
          alt="Tarh Logo"
          className="h-12 w-auto relative z-10"
        />
      </div>
    </div>
  );
}
